import DiffLine from './diff-line.entity';

export default class RuleVersionDiff {
  fromVersion: string;

  toVersion: string;

  scriptLines: DiffLine[];

  parameterLines: DiffLine[];

  constructor(obj: any = {}) {
    this.fromVersion = obj.fromVersion || '';
    this.toVersion = obj.toVersion || '';
    this.scriptLines = obj.scriptLines ? DiffLine.ofList(obj.scriptLines) : [];
    this.parameterLines = obj.parameterLines ? DiffLine.ofList(obj.parameterLines) : [];
  }

  public static of(obj: any = {}): RuleVersionDiff {
    return new RuleVersionDiff(obj);
  }
}
